export function NightyNineMax(num){
    if(num >= 99 ) {
        return 99;
    }else{
        return num;
    }
}